import React from 'react';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { DataList, formatListData } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { actions } from '../../actions/conversions';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { conversionsConfig, DEFAULT_CONFIG } from './conversionsConfig';

const useConversions = () => {
	const location = useLocation();
	const getConversionsData = () => {
		const configs = _get(location, ['state', 'rowData', 'withdrawalFee'])?.range?.map((config: any, index: number) => {
			return {
				startRange: config?.range?.start,
				endRange: config?.range?.end,
				percentage: config?.percentage,
				flatValue: config?.flatValue,
				index: index + 1
			};
		});
		return { rowCount: configs?.length, data: formatListData(configs) };
	};
	const { getActionHandler } = useDashboardActions(makeActionHandler, makeActionList);
	return { getConversionsData, getActionHandler };
};

const Conversions: React.FC<{}> = () => {
	const { getConversionsData, getActionHandler } = useConversions();
	return (
		<div>
			<DataList
				fetchData={getConversionsData}
				columnConfigs={conversionsConfig}
				defaults={DEFAULT_CONFIG}
				actions={actions}
				getActionHandler={getActionHandler}
				disableColumnFilter
				entity={LIST_ENTITY_NAMES.CTD_CONFIGS}
			/>
		</div>
	);
};

export default Conversions;
